/** Shared loading / error / empty presentational blocks for data views. */
import React from "react";
import { AlertTriangle, Inbox, RefreshCw } from "lucide-react";
import { Spinner } from "./Spinner";
import { getErrorMessage } from "../../lib/errors";

export const LoadingState: React.FC<{ label?: string }> = ({
  label = "Loading…",
}) => (
  <div className="flex flex-col items-center justify-center gap-3 py-16 text-slate-400">
    <Spinner size={28} className="text-blue-500" />
    <p className="text-sm">{label}</p>
  </div>
);

export const ErrorState: React.FC<{
  error: unknown;
  onRetry?: () => void;
}> = ({ error, onRetry }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
    <AlertTriangle size={28} className="text-red-400" />
    <p className="max-w-md text-sm text-slate-300">{getErrorMessage(error)}</p>
    {onRetry && (
      <button onClick={onRetry} className="btn-secondary mt-2 inline-flex items-center gap-2">
        <RefreshCw size={16} /> Retry
      </button>
    )}
  </div>
);

export const EmptyState: React.FC<{
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}> = ({ title, description, icon, action }) => (
  <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
    <div className="mb-1 text-slate-500">{icon ?? <Inbox size={32} />}</div>
    <h3 className="font-semibold text-slate-200">{title}</h3>
    {description && (
      <p className="max-w-md text-sm text-slate-400">{description}</p>
    )}
    {action && <div className="mt-3">{action}</div>}
  </div>
);
